export default "__VITE_ASSET__CTQrava1__"